export default __webpack_public_path__ + "static/media/close.843061b9.svg";